<template>
  <div
    :class="{
      'dayplanner-topbar d-flex': true,
      'hamburger-spacer': !showSidebar,
    }"
    v-responsive="{
      'wrapper-tiny': el => el.width <= 450,
      'wrapper-small': el => el.width <= 800,
      'wrapper-wide': el => el.width > 800
    }"
    style="align-items: center; justify-content: space-between;">

    <div class="ml-3 dayplanner-topbar__left">
      <el-button @click="showSidebar = !showSidebar" style="margin-top: 1px;">
        <font-awesome-icon :icon="[ 'fas', showSidebar ? 'chevron-left' : 'chevron-right' ]"/>
      </el-button>
      <el-button @click="onGoToTableViewGoal(false)" v-if="$route.name === 'weekplanner' || $route.name === 'monthplanner'" class="ml-1" style="padding: 12px 14px;">
        <font-awesome-icon icon="stream" />
        <span class="hide-when-small ml-1">&nbsp;Day planner</span>
      </el-button>
      <!--
      <el-button @click="onGoToTableViewGoal(true)" v-else>
        <font-awesome-icon icon="table" />
        <span class="hide-when-small ml-1">&nbsp;Table</span>
      </el-button>
      -->
      <el-button @click="onGoToMonthPlanner(true)" v-if="$route.name === 'dayplanner' || $route.name === 'dayplanner-taskpage'" class="ml-1" style="padding: 12px 14px;">
        <font-awesome-icon icon="calendar-alt" />
        <span class="hide-when-small ml-1">&nbsp;Month planner</span>
      </el-button>
    </div>

    <!--
    <el-button-group class="ml-3">
      <el-button size="small" @click="onCalendarNavigation('prevday')">
        <font-awesome-icon icon="angle-left"/>&nbsp;
        <strong>Day</strong>
      </el-button>
      <el-button size="small" @click="onCalendarNavigation('nextday')">
        <strong>Day</strong>&nbsp;
        <font-awesome-icon icon="angle-right"/>
      </el-button>
    </el-button-group>

    <el-button-group class="mr-2">
      <el-button
        class
        size="small"
        @click="onUndo(-1)"
        :disabled="snapshot_stack.length === 0">
        <font-awesome-icon icon="undo" title="Undo"/>
        ( {{snapshot_stack.length}} )
      </el-button>
      <el-button
        class
        size="small"
        @click="onUndo(+1)"
        :disabled="snapshot_stack_redo.length === 0">
        <font-awesome-icon icon="redo" title="Redo"/>
        ( {{snapshot_stack_redo.length}} )
      </el-button>
    </el-button-group>
    -->

    <el-button-group>
      <el-button @click="onCalendarNavigation(isMonthView ? 'prevmonth' : 'prevday')" style="cursor: pointer; padding: 5px 20px;">
        <font-awesome-icon icon="caret-left" size="2x" />
      </el-button>

      <!-- TODO: component <DayplannerDateselect /> -->
      <el-popover class="el-button el-button--default dayplanner-topbar__date" width="470">

        <span slot="reference" class="dayplanner-topbar__date-text">
          <span class="hide-when-tiny">
            <template v-if="isMonthView">
              {{view_from_date|monthFromDate}}
            </template>
            <template v-else>
              <template v-if="view_is_multi_day">
                {{[view_from_date, view_to_date]|longDateRange}}
              </template>
              <template v-else>
                {{view_from_date|longDateWithDay}}
              </template>
            </template>
          </span>
          <span class="show-when-tiny">
            <font-awesome-icon icon="ellipsis-h" />
          </span>
        </span>

        <div>
          <!-- TODO: Simplify !! -->

          <div class="d-flex justify-content-between align-items-center">

            <font-awesome-icon icon="calendar-alt" size="2x" />

            <el-button @click="onCalendarNavigation('today')" style="height: 40px">
              <strong>Today</strong>
            </el-button>

            <el-date-picker
              class="d-block"
              :value="view_from_date"
              @input="onCalendarNavigation('jumpto', $event)"
              type="date"
              placeholder="Pick a date">
            </el-date-picker>
          </div>

          <hr />

          <el-button-group class="w-100">
            <el-button @click="onCalendarNavigation('days_from_today', 1)">Today + 1</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 2)">+ 2</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 3)">+ 3</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 4)">+ 4</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 5)">+ 5</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 6)">+ 6</el-button>
            <el-button @click="onCalendarNavigation('days_from_today', 7)">+ 7</el-button>
          </el-button-group>

          <el-date-picker
            class="w-100 mt-3"
            style="word-break: normal;"
            v-model="viewDateRange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date">
          </el-date-picker>

        </div>
      </el-popover>
      <el-button @click="onCalendarNavigation(isMonthView ? 'nextmonth' :  'nextday')" style="cursor: pointer; padding: 5px 20px;">
        <font-awesome-icon icon="caret-right" size="2x" />
      </el-button>
    </el-button-group>

    <div class="dayplanner-topbar__right d-flex align-items-center justify-content-end">
      <template
        v-if="!view_is_multi_day && !isMonthView"
        class="">

        <font-awesome-icon size="lg"
          :icon="['fas', 'columns']"
          @click="columnLayout = false"
          :color="[ columnLayout ? '#999': 'black' ]"
          class="ml-2 hide-when-small"
          style="cursor: pointer;" />
        <font-awesome-icon size="lg"
          :icon="['fas', 'th-large']"
          @click="columnLayout = true"
          :color="[ !columnLayout ? '#999': 'black' ]"
          class="ml-2 hide-when-small"
          style="cursor: pointer;"/>
        <font-awesome-icon
          color="#ccc"
          icon="lock"
          @click="showReducedDayplan = false"
          class="ml-2 hide-when-small"
          v-show="showReducedDayplan" />
      </template>

      <ellipsis-button
        heading="Dayplan"
        :show-options="['slot']"
        iconSize="2x"
        class="mr-2"
        style="display: inline-block; margin-left: 0.5em;">
        <!--
          height: 40px; padding: 7px 12px;
          :icon="['fa', 'cloud-download-alt']"
          iconColor="#000000"
        -->

        <el-button class="btn-block ml-0 text-left" size="small" @click="onExport">
          <font-awesome-icon icon="file-download"/> Export
        </el-button>

        <el-button class="btn-block ml-0 text-left" size="small" @click="onPrint">
          <font-awesome-icon icon="print"/> Print
        </el-button>

        <el-button class="btn-block ml-0 text-left" size="small" @click="$root.showModal('background')">
          <font-awesome-icon icon="image" />
          Change Background
        </el-button>

        <el-button
          class="btn-block ml-0 text-left"
          size="small"
          @click="onImportFromGoogleCalendar( view_selected_date )">
          <i class="el-icon-download"></i> Import this day
          <br>from Google Calendar
        </el-button>

        <el-button
          class="btn-block ml-0 text-left"
          size="small"
          @click="onExportToGoogleCalendar( view_selected_date, draggablesList )">
          <i class="el-icon-upload2"></i> Export this day
          <br>to Google Calendar
        </el-button>

        <el-checkbox class="p-2" v-model="showNothingPlanned">Show "Nothing planned"</el-checkbox>

        <template v-if="!is_production">
          <div class="dropdown-divider"></div>
          DEBUG:
          <el-checkbox class="p-2" :value="SHOW_DEBUG" @input="onClickShowDebug">Show Debug</el-checkbox>
          <el-button class="btn-block ml-0" size="small" @click="onDebugReset">Reset</el-button>
        </template>
        <!--<el-button class="btn-block ml-0" size="small" @click="onDebugInit">Init (Autoplan)</el-button>-->
      </ellipsis-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from '@/moment-gp'
import util from '@/util'
import GoogleCalendarMixin from "@/components/TodayPage/Elements/GoogleCalendarMixin";

// TODO: Menü öffnet sich teilweise nicht

export default {

  mixins: [ GoogleCalendarMixin ],
  data: () => ({
    // TODO: Vuex store
    // currentDate: null,
    snapshot_stack: [],
    snapshot_stack_redo: [],
    is_production: process.env.VUE_APP_PRODUCTION !== 'false',
  }),
  mounted() {
    // TODO: Move to App-Store / Dayplanner-Store
    // this.currentDate = moment.currentDate();
  },
  watch: {
    currentDate: {
      handler(newCurrentDate, oldCurrentDate) {
        console.log("WATCHER: currentDate", newCurrentDate);

        /*
        this.dateString = newCurrentDate.format("YYMMDD");

        log2("dateTimestamp before:", clonedeep(this.dateTimestamp));
        this.dateTimestamp = newCurrentDate
          .clone()
          .startOf("day")
          .unix();
        log2("dateTimestamp after:", clonedeep(this.dateTimestamp));
        */

        //let stored_dayplan = localStorage.getItem("dayplan." + this.dateString)

        // TODO: try { } catch { }
        /*this.dayplan = stored_dayplan
                    ? JSON.parse(stored_dayplan)
                    : make_dummy_plan(this.dateString);
        this.dayplan.nonUserUpdate = true;

        //this.createSnapshot( this.dayplan )*/

        // this.dayplan = make_dummy_plan();
      },
      deep: true, // TODO: Improve
    },
  },
  computed: {
    ...mapGetters('app', [
      'dayplanner_sidebar',
    ]),
    ...mapGetters('dayplanner', [
      'dayplan_from_db_at_selected_day',
      'column_layout',
      'show_nothing_planned',
      'show_reduced_dayplan',
      'view_from_date',
      'view_to_date',
      'view_selected_date',
      'view_is_multi_day',
    ]),

    isMonthView() {
      return this.$route.name === 'monthplanner';
    },

    columnLayout: {
      get() { return this.column_layout; },
      set(value) { this.SET_COLUMN_LAYOUT(value) }
    },

    showReducedDayplan: {
      get() { return this.show_reduced_dayplan; },
      set(value) { this.TOGGLE_SHOW_REDUCED_DAYPLAN() }
    },

    showSidebar: {
      get() { return this.dayplanner_sidebar; },
      set(value) { this.setDayplannerSidebar(value) }
    },

    showNothingPlanned: {
      get() { return this.show_nothing_planned; },
      set(value) { this.SET_SHOW_NOTHING_PLANNED(value) }
    },

    viewDateRange: {
      get() {
        return [ this.view_from_date, this.view_to_date ];
      },
      set(value) {
        this.SET_VIEW_RANGE({ from: value[0], to: value[1] })
      }
    },

  },
  methods: {
    ...mapActions('app', [
      'setDayplannerSidebar',
    ]),
    ...mapActions('dayplanner', [
      'initializeDayplanner',
      'debugReset',
    ]),
    ...mapMutations('dayplanner', [
      'SET_VIEW_RANGE',
      'SELECT_DATE',
      'SET_COLUMN_LAYOUT',
      'SET_SHOW_NOTHING_PLANNED',
      'TOGGLE_SHOW_REDUCED_DAYPLAN',
      'HIDE_BACKLOG_ALL',
    ]),

    onGoToTableViewGoal( mode ) {
      return mode
        ? this.$router.push('/weekplanner')
        : this.$router.push('/dayplanner')
    },

    onGoToMonthPlanner( mode ) {
      return mode
        ? this.$router.push('/monthplanner')
        : this.$router.push('/dayplanner')
    },

    onCalendarNavigation(action, days = null) {
      // HACK: Undo/Redo does not save date specific information
      this.snapshot_stack = [];
      this.snapshot_stack_redo = [];

      let delta = this.view_is_multi_day
                ? this.view_to_date.diff( this.view_from_date, 'days' ) + 1
                : 1;

      console.log("onCalendarNavigation", action, days, delta)

      let new_from_date = null;
      let new_to_date = null;
      switch ( action ) {
        case "prevpage":
          new_from_date = this.view_from_date.subtract(delta, "days");
          new_to_date   = this.view_is_multi_day ? this.view_to_date.subtract(delta, "days") : null;
        break

        case "nextpage":
          new_from_date = this.view_from_date.add(delta, "days");
          new_to_date   = this.view_is_multi_day ? this.view_to_date.add(delta, "days") : null;
        break

        case "prevday":
          new_from_date = this.view_from_date.subtract(1, "days");
          new_to_date   = this.view_is_multi_day ? this.view_to_date.subtract(1, "days") : null;
        break

        case "nextday":
          new_from_date = this.view_from_date.add(1, "days");
          //new_to_date   = this.view_to_date.add(1, "days");
          new_to_date   = this.view_is_multi_day ? this.view_to_date.add(1, "days") : null;
        break

        case "prevmonth":
          new_from_date = this.view_from_date.subtract(1, "month");
          new_to_date   = null;
        break

        case "nextmonth":
          new_from_date = this.view_from_date.add(1, "month");
          new_to_date   = null;
        break

        case "today":
          new_from_date = moment.currentDate();
          new_to_date   = null;
        break

        case "days_from_today":
          new_from_date = moment.currentDate();
          new_to_date   = new_from_date.clone().add( days, "days");
        break

        case "jumpto":
          new_from_date = moment( days );
          new_to_date   = null;
        break
      }

      if (new_from_date) {

        this.SET_VIEW_RANGE({
          from: new_from_date.toStore(),
          to:   new_to_date ? new_to_date.toStore() : null
        });

        // ...also select the currently visible date, when only one day is shown
        // if ( !this.view_is_multi_day ) {
        this.SELECT_DATE( new_from_date.toStore() )
        // }

        this.HIDE_BACKLOG_ALL();
      }
    },

    onClickShowDebug(value) {
      this.$store.commit("app/SET_DEBUG", value);
    },

    onDebugReset() {
      this.debugReset();
    },

    onExport(save_to_file) {
      // TODO: Pdf (see PDFKit), XLSX
      util.saveJSON(this.dayplan_from_db_at_selected_day, moment().format("YYYY-MM-DD_HH-MM") + "_dayplan.json");
    },

    onPrint() {
      window.print();
    },

    onUndo(count) {
      console.log("onUndo", count);
      /*if ( count < 0 ) {
        this.snapshot_stack_redo.push( this.dayplan ); // clone?
        this.dayplan = this.snapshot_stack.pop();
        this.dayplan.nonUserUpdate = true;
      } else {
        this.snapshot_stack.push( this.dayplan );
        this.dayplan = this.snapshot_stack_redo.pop()
        this.dayplan.nonUserUpdate = true;
      }*/
    },
  },
  filters: {
    monthFromDate(date) {
      return moment(date).format('MMMM');
    },
  },
  components: {
  }
}
</script>

<style>
.show-when-tiny {
  display: none;
}
.dayplanner-topbar.wrapper-tiny .show-when-tiny {
  display: block;
}
.dayplanner-topbar.wrapper-small .hide-when-small,
.dayplanner-topbar.wrapper-tiny .hide-when-tiny {
  display: none !important;
}
.dayplanner-topbar.wrapper-small .dayplanner-topbar__date-text {
  font-size: 12pt;
  height: 38px;
}
.dayplanner-topbar.wrapper-small .dayplanner-topbar__date {
  padding: 0 10px;
  /*border-radius: 4px !important;*/
  border-radius: 0 !important;
  height: 38px;
}
.dayplanner-topbar__date-text {
  display: table-cell;
  vertical-align: middle;
  height: 35px;
}
.dayplanner-topbar__date {
  font-size: 16pt;
  font-weight: bold;
  height: 40px;
  padding: 0 12px;
}
.dayplanner-topbar__left,
.dayplanner-topbar__right {
  flex: 0 0 195px;
}
.dayplanner-topbar.wrapper-small .dayplanner-topbar__left,
.dayplanner-topbar.wrapper-small .dayplanner-topbar__right {
  flex: unset;
}
</style>
